import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import CreatePM from "./Tabs/createPM";
import WorkOrder from "./Tabs/workorder";
import WorkingPlan from "./Tabs/workingplan";

export default function CreatePlanPM() {
  const { state } = useLocation();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        create: "การสร้างแผน PM",
        working_plan: "กำหนดแผนเข้าทำงาน PM แต่ละสาขา",
        work_order: "สร้างใบสั่งงาน Service Request"
      }
    });
  };

  useEffect(() => handleChangeTab(state?.name || "create"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Create PM Plan Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          className="scrollable-tabs"
          defaultActiveKey={state?.name || "create"}
          onSelect={handleChangeTab}
        >
          <Tab eventKey="create" title="การสร้างแผน PM">
            {websiteName === "การสร้างแผน PM" && <CreatePM />}
          </Tab>
          <Tab eventKey="working_plan" title="กำหนดแผนเข้าทำงาน PM แต่ละสาขา">
            {websiteName === "กำหนดแผนเข้าทำงาน PM แต่ละสาขา" && (
              <WorkingPlan />
            )}
          </Tab>
          <Tab eventKey="work_order" title="สร้างใบสั่งงาน Service Request">
            {websiteName === "สร้างใบสั่งงาน Service Request" && <WorkOrder />}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
